import { BodyText, Container, HeadingText, Link } from '@paypalcorp/pp-react';
import { Message } from '@paypalcorp/worldready-react';
import React from 'react';
import PropTypes from 'prop-types';

function BrexitComplaintsDataComponent(props) {
  const { openSheetEvent } = props;
  return (
    <Container className="brexit_complaints_data" data-testid="brexit-complaints-data">
      <HeadingText className="brexit_complaints_data__title" data-testid="brexit-complaints-data-title">
        <Message id="smarthelp.complaints.complaintsData.headingText" />
      </HeadingText>
      <BodyText className="brexit_complaints_data__text" data-testid="brexit-complaints-data-text-disclaimer">
        <Message id="smarthelp.complaints.complaintsData.disclaimer" />
      </BodyText>
      <BodyText className="brexit_complaints_data__text" data-testid="brexit-complaints-data-text-summary">
        <Message id="smarthelp.complaints.complaintsData.summary" />
        &nbsp;
        <Link onClick={openSheetEvent} data-testid="brexit-complaints-data-text-summary-link">
          <Message id="smarthelp.complaints.complaintsData.here" />
        </Link>
      </BodyText>
    </Container>
  );
}

BrexitComplaintsDataComponent.propTypes = {
  openSheetEvent: PropTypes.func.isRequired,
};

export default BrexitComplaintsDataComponent;
